import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const loggedInUser = localStorage.getItem('loggedInUser');
    const selectedBranch = localStorage.getItem('selectedBranch');
    if (loggedInUser) {
      const headers: Record<string, string> = { 'X-User': loggedInUser };
      // supersysadmin branch picker — backend ignores this for other roles
      if (selectedBranch && selectedBranch !== 'ALL') {
        headers['X-Branch'] = selectedBranch;
      }
      request = request.clone({ setHeaders: headers });
    }
    return next.handle(request);
  }
}
